//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "",
  data() {
    return {};
  },
  components: {},
  created() {},
  mounted() {},

  methods: {}
};



// WEBPACK FOOTER //
// ./src/components/pay/success.vue